import React from 'react';
import Lottie from 'lottie-react';
import citySkylineAnimation from '../../assets/animations/CitySkyline.json';

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Cargando...',
  fullScreen = true
}) => {
  const containerClasses = fullScreen
    ? 'fixed inset-0 bg-background z-50'
    : 'w-full h-full bg-background';

  return (
    <div className={`${containerClasses} flex flex-col items-center justify-center`}>
      <div className="mb-6 w-96 h-96 drop-shadow-lg">
        <Lottie
          animationData={citySkylineAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
      {message && (
        <div className="space-y-2 text-center">
          <p className="text-2xl font-semibold tracking-wide text-foreground animate-pulse">
            {message}
          </p>
          <div className="flex justify-center mt-4 space-x-3">
            <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingScreen;
